import {Stack} from "@mui/material";
import React, {useState} from "react";
import {GraphQueryFilterDto} from "../../../../common/apis/query/GraphQueryFilterDto";
import RenderMode from "../diagrams/RenderMode";
import GraphQueryFilter from "./GraphQueryFilter";
import GraphQueryGrid, {GraphQueryGridProps} from "./GraphQueryGrid";

export interface GraphQueryGridWithFilterProps extends GraphQueryGridProps {
}

export default function GraphQueryGridWithFilter({mode, onGridRowChange, resourceId}: GraphQueryGridWithFilterProps) {

    const [queryFilter, setQueryFilter] = useState<GraphQueryFilterDto>();

    return (
            <Stack spacing={2}>
                <GraphQueryFilter onFilterChange={setQueryFilter}
                        renderMode={RenderMode.PAGE}/>
                <GraphQueryGrid queryFilter={queryFilter}
                        mode={mode}
                        onGridRowChange={onGridRowChange}
                        resourceId={resourceId}/>
            </Stack>
    );
}
